export default "__VITE_ASSET__DCeFkssp__"